import React from 'react';
import { Link } from 'react-router-dom';
import { PackageIcon, ShoppingCartIcon, UsersIcon, DollarSignIcon, TrendingUpIcon, TrendingDownIcon, BoxIcon, TruckIcon, TagIcon, BarChart3Icon, SettingsIcon, BellIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { formatPrice } from '../../utils/formatters';
const stats = [{
  label: 'Total Revenue',
  value: formatPrice(2450000),
  change: '+12.5%',
  trend: 'up',
  icon: DollarSignIcon,
  color: 'bg-green-100 text-green-600'
}, {
  label: 'Total Orders',
  value: '1,234',
  change: '+8.2%',
  trend: 'up',
  icon: ShoppingCartIcon,
  color: 'bg-blue-100 text-blue-600'
}, {
  label: 'Total Products',
  value: '456',
  change: '+3.1%',
  trend: 'up',
  icon: PackageIcon,
  color: 'bg-purple-100 text-purple-600'
}, {
  label: 'Total Customers',
  value: '8,901',
  change: '+15.3%',
  trend: 'up',
  icon: UsersIcon,
  color: 'bg-orange-100 text-orange-600'
}];
const recentOrders = [{
  id: 'GZ-001234',
  customer: 'Ahmed Khan',
  amount: 45999,
  status: 'delivered',
  date: '2024-01-20'
}, {
  id: 'GZ-001235',
  customer: 'Sara Ahmed',
  amount: 12999,
  status: 'shipped',
  date: '2024-01-20'
}, {
  id: 'GZ-001236',
  customer: 'Ali Hassan',
  amount: 67999,
  status: 'processing',
  date: '2024-01-19'
}, {
  id: 'GZ-001237',
  customer: 'Fatima Khan',
  amount: 8999,
  status: 'pending',
  date: '2024-01-19'
}, {
  id: 'GZ-001238',
  customer: 'Usman Ali',
  amount: 24999,
  status: 'delivered',
  date: '2024-01-18'
}];
const statusColors: Record<string, string> = {
  pending: 'bg-yellow-100 text-yellow-700',
  processing: 'bg-blue-100 text-blue-700',
  shipped: 'bg-purple-100 text-purple-700',
  delivered: 'bg-green-100 text-green-700',
  cancelled: 'bg-red-100 text-red-700'
};
const menuItems = [{
  icon: BarChart3Icon,
  label: 'Dashboard',
  href: '/admin',
  active: true
}, {
  icon: PackageIcon,
  label: 'Products',
  href: '/admin/products'
}, {
  icon: ShoppingCartIcon,
  label: 'Orders',
  href: '/admin/orders'
}, {
  icon: UsersIcon,
  label: 'Customers',
  href: '/admin/customers'
}, {
  icon: BoxIcon,
  label: 'Inventory',
  href: '/admin/inventory'
}, {
  icon: TruckIcon,
  label: 'Shipping',
  href: '/admin/shipping'
}, {
  icon: TagIcon,
  label: 'Coupons',
  href: '/admin/coupons'
}, {
  icon: SettingsIcon,
  label: 'Settings',
  href: '/admin/settings'
}];
export function AdminDashboard() {
  return <div className="min-h-screen bg-gray-100" data-id="element-1043" data-mp="1y60brw87uuym">
      {/* Admin header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40" data-id="element-1044" data-mp="1y3xd6nszztia">
        <div className="flex items-center justify-between px-6 py-4" data-id="element-1045" data-mp="2341v8i9k0wam">
          <div className="flex items-center gap-4" data-id="element-1046" data-mp="27x4qqvxw6ftg">
            <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="Gadgets Zone" className="h-10 w-auto object-contain" data-id="element-1047" data-mp="27xxstjlwoh59" />
            <div data-id="element-1048" data-mp="1fdpcsdgonh5s">
              <h1 className="text-lg font-bold text-gray-900" data-id="element-1049" data-mp="17w9bm3yfuaqu">Gadgets Zone</h1>
              <p className="text-xs text-gray-500" data-id="element-1050" data-mp="17u6nxqkrctpa">Admin Dashboard</p>
            </div>
          </div>
          <div className="flex items-center gap-4" data-id="element-1051" data-mp="12v3meg3zl5m2">
            <button className="relative p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg" data-id="element-1052" data-mp="xx21rqqwwy8h">
              <BellIcon className="w-5 h-5" data-id="element-1053" data-mp="tvq6p5p9rksw" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" data-id="element-1054" data-mp="oxey0yapngc9" />
            </button>
            <div className="flex items-center gap-3" data-id="element-1055" data-mp="k6ykzfasxwqf">
              <div className="w-9 h-9 bg-primary-100 rounded-full flex items-center justify-center" data-id="element-1056" data-mp="k540u37cu8ne">
                <span className="text-primary-600 font-medium" data-id="element-1057" data-mp="f858nq794bru">A</span>
              </div>
              <div className="hidden sm:block" data-id="element-1058" data-mp="aa3nmzq9m2dq">
                <p className="text-sm font-medium text-gray-900" data-id="element-1059" data-mp="66nsy8xrac3o">Admin</p>
                <p className="text-xs text-gray-500" data-id="element-1060" data-mp="690688skjyae">admin@gadgetszone.pk</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="flex" data-id="element-1061" data-mp="21b4zq6elj634">
        {/* Sidebar */}
        <aside className="w-64 bg-white border-r border-gray-200 min-h-[calc(100vh-73px)] hidden lg:block" data-id="element-1062" data-mp="21cg5ucvikpxe">
          <nav className="p-4 space-y-1" data-id="element-1063" data-mp="1rkad30xfu4h5">
            {menuItems.map(item => <Link key={item.label} to={item.href} className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${item.active ? 'bg-primary-50 text-primary-600' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1064" data-mp="1rk0nhegb1zbz">
                <item.icon className="w-5 h-5" data-id="element-1065" data-mp="1hofq5tm6ln8k" />
                <span className="font-medium" data-id="element-1066" data-mp="1mm8usi7u696q">{item.label}</span>
              </Link>)}
          </nav>
        </aside>

        {/* Main content */}
        <main className="flex-1 p-6" data-id="element-1067" data-mp="18nhmxdjkhjr1">
          {/* Page header */}
          <div className="flex items-center justify-between mb-6" data-id="element-1068" data-mp="1dlapzxpkpxn3">
            <div data-id="element-1069" data-mp="32ywdfwkejn7u">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-1070" data-mp="330h6tiuzd044">Dashboard</h2>
              <p className="text-gray-500" data-id="element-1071" data-mp="37z25veyhxdqz">
                Welcome back! Here's what's happening today.
              </p>
            </div>
            <div className="flex gap-3" data-id="element-1072" data-mp="3i2z12juxxsd2">
              <Button variant="outline" data-id="element-1073" data-mp="3d3cmo73dm62o">Export Report</Button>
              <Button variant="primary" data-id="element-1074" data-mp="3d57bvxlokkck">Add Product</Button>
            </div>
          </div>

          {/* Stats grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1075" data-mp="3qwlx8b328xms">
            {stats.map(stat => <Card key={stat.label} padding="lg" data-id="element-1076" data-mp="4nkmdwt9kckc">
                <div className="flex items-start justify-between" data-id="element-1077" data-mp="4m9hturzv0s6">
                  <div data-id="element-1078" data-mp="3vudm0w8es3mr">
                    <p className="text-sm text-gray-500" data-id="element-1079" data-mp="3vssuzglaz2tn">{stat.label}</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1080" data-mp="dor76i2y49je">
                      {stat.value}
                    </p>
                    <div className="flex items-center gap-1 mt-2" data-id="element-1081" data-mp="9nyvli6lpsjy">
                      {stat.trend === 'up' ? <TrendingUpIcon className="w-4 h-4 text-green-500" data-id="element-1082" data-mp="2fgnjhtwxtnf8" /> : <TrendingDownIcon className="w-4 h-4 text-red-500" data-id="element-1083" data-mp="2be0m7dhhzaan" />}
                      <span className={stat.trend === 'up' ? 'text-green-600' : 'text-red-600'} data-id="element-1084" data-mp="2bg3l6n0modri">
                        {stat.change}
                      </span>
                      <span className="text-gray-400 text-sm" data-id="element-1085" data-mp="jdipc6ig0t1i">
                        vs last month
                      </span>
                    </div>
                  </div>
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${stat.color}`} data-id="element-1086" data-mp="tb6od8n30mph">
                    <stat.icon className="w-6 h-6" data-id="element-1087" data-mp="xd0isz6oouh7" />
                  </div>
                </div>
              </Card>)}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1088" data-mp="129qw5er3tbyx">
            {/* Recent orders */}
            <div className="lg:col-span-2" data-id="element-1089" data-mp="172tvk3ikbfn1">
              <Card padding="none" data-id="element-1090" data-mp="1c0vd2k0cb6we">
                <div className="p-4 border-b border-gray-100 flex items-center justify-between" data-id="element-1091" data-mp="1bztr3khsczzw">
                  <h3 className="font-semibold text-gray-900" data-id="element-1092" data-mp="1h1j1qz13jbng">Recent Orders</h3>
                  <Link to="/admin/orders" className="text-primary-600 hover:text-primary-700 text-sm font-medium" data-id="element-1093" data-mp="1l11p01ge3ytg">
                    View All
                  </Link>
                </div>
                <div className="overflow-x-auto" data-id="element-1094" data-mp="31hqwud501in2">
                  <table className="w-full" data-id="element-1095" data-mp="31gz3za2sdz0h">
                    <thead className="bg-gray-50" data-id="element-1096" data-mp="2wins6tsxlefm">
                      <tr data-id="element-1097" data-mp="2wjfknvr8ew1o">
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1098" data-mp="2rk2scvhlcwrp">
                          Order ID
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1099" data-mp="3p71o940gm0oj">
                          Customer
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1100" data-mp="3fh03al3ekydu">
                          Amount
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1101" data-mp="bsonqub3hnhr">
                          Status
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1102" data-mp="70587rsukiab">
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100" data-id="element-1103" data-mp="32jczi28yxfhq">
                      {recentOrders.map(order => <tr key={order.id} className="hover:bg-gray-50" data-id="element-1104" data-mp="32hjqwhesol73">
                          <td className="px-4 py-3 text-sm font-medium text-gray-900" data-id="element-1105" data-mp="36l7yv17c9isv">
                            {order.id}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-600" data-id="element-1106" data-mp="34rc7r2aqenw">
                            {order.customer}
                          </td>
                          <td className="px-4 py-3 text-sm font-medium text-gray-900" data-id="element-1107" data-mp="3lbyqo98xkhvz">
                            {formatPrice(order.amount)}
                          </td>
                          <td className="px-4 py-3" data-id="element-1108" data-mp="29twc5j07gosd">
                            <span className={`px-2 py-1 text-xs font-medium rounded-full capitalize ${statusColors[order.status]}`} data-id="element-1109" data-mp="2etinfmwh3uyj">
                              {order.status}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-500" data-id="element-1110" data-mp="22aenjr83t8oy">
                            {order.date}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>

            {/* Quick actions & alerts */}
            <div className="space-y-6" data-id="element-1111" data-mp="1nk7eu37wf41g">
              <Card padding="lg" data-id="element-1112" data-mp="1inpah4ghd7pn">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-1113" data-mp="1ios1rdhptc63">
                  Quick Actions
                </h3>
                <div className="space-y-3" data-id="element-1114" data-mp="1xe6bimp7dvm0">
                  <Button variant="outline" fullWidth className="justify-start" data-id="element-1115" data-mp="1skv68q01hmw7">
                    <PackageIcon className="w-4 h-4 mr-2" data-id="element-1116" data-mp="14vivhlp2d6rs" />
                    Add New Product
                  </Button>
                  <Button variant="outline" fullWidth className="justify-start" data-id="element-1117" data-mp="zxhc0znq75fs">
                    <TagIcon className="w-4 h-4 mr-2" data-id="element-1118" data-mp="2qbc1pqnxrrxg" />
                    Create Coupon
                  </Button>
                  <Button variant="outline" fullWidth className="justify-start" data-id="element-1119" data-mp="2lc95mvpxow1m">
                    <TruckIcon className="w-4 h-4 mr-2" data-id="element-1120" data-mp="2gd60zcdv8ru6" />
                    Update Shipping
                  </Button>
                </div>
              </Card>

              <Card padding="lg" data-id="element-1121" data-mp="2bgfjckmexo6n">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-1122" data-mp="27chlsecqklfp">Alerts</h3>
                <div className="space-y-3" data-id="element-1123" data-mp="27ekkrnvv9owk">
                  <div className="flex items-start gap-3 p-3 bg-yellow-50 rounded-lg" data-id="element-1124" data-mp="22kzu6gwlrx7e">
                    <BoxIcon className="w-5 h-5 text-yellow-600 flex-shrink-0" data-id="element-1125" data-mp="1xmepa46eopcm" />
                    <div data-id="element-1126" data-mp="1so3ik2bequym">
                      <p className="text-sm font-medium text-yellow-800" data-id="element-1127" data-mp="1somsavqwmd1k">
                        Low Stock Alert
                      </p>
                      <p className="text-xs text-yellow-600" data-id="element-1128" data-mp="1nquytxam2iv9">
                        5 products are running low
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg" data-id="element-1129" data-mp="3v9z6t74h591m">
                    <ShoppingCartIcon className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-1130" data-mp="35epem4r3kw9" />
                    <div data-id="element-1131" data-mp="86udyo6509je">
                      <p className="text-sm font-medium text-blue-800" data-id="element-1132" data-mp="86lxynepwo3z">
                        New Orders
                      </p>
                      <p className="text-xs text-blue-600" data-id="element-1133" data-mp="3bmjd7arqkm96">
                        12 orders pending review
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </main>
      </div>
    </div>;
}